<template>
    <div class="contact-component">
        <div style="position: relative;">
            <div class="back"></div>
            <b-container class="contact">
                <div id="contacto" style="position: absolute; top: -100px;"></div>
                <b-row>
                <b-col lg="12">
                    <img class="logo-footer" src="../assets/imgs/logo.svg" alt="">
                </b-col>
                <b-col class="mb-4" md="4">
                    <h4 class="mb-2">Conoce tu nuevo hogar</h4>
                    <p>Llena el formulario con tus datos para más información</p>
                    <p class="error" v-if="messageSend">{{ messageSend }}</p>
                    <b-form-input class="mb-2" id="input-1" v-model="name" placeholder="Nombre:" type="text"></b-form-input>
                    <b-form-input class="mb-2" id="input-2" v-model="phone" placeholder="Teléfono:" type="text"></b-form-input>
                    <b-form-textarea class="mb-2" id="input-3" v-model="message" placeholder="Comentario:" rows="6" max-rows="3"></b-form-textarea>
                    <b-form-input autocomplete="off" tabindex="-1" id="input-1" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
                    <b-button class="btn-enviar" v-on:click="sendMessage">Enviar <img src="../assets/imgs/arrow2.svg" alt=""></b-button>
                </b-col>
                <b-col class="contact-info mb-4" offset-lg="2" lg="6" offset-md="1" md="7" style="position: relative;">
                    <h4>Datos</h4>
                    <p class="contact-text"> <img src="../assets/imgs/telefono.svg"/> <b>Samara</b><br>686 391 2095 <br><span class="phoneCoto"><b>Coto Sur</b><br>686 192 4713</span></p>
                    <p class="contact-text"> <img src="../assets/imgs/correo.svg"/><a href="mailto:info@arialife.mx">info@arialife.mx</a></p>
                </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <a href="https://www.facebook.com/arialifedesarrollos"><img src="../assets/imgs/Facebook.png"></a>
                  </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
    export default {
        data() {
            return {
                slickOptions: {
                    autoplay: true,
                    autoplaySpeed: 10000,
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    focusOnSelect: true,
                    speed: 1000,
                },
                name: '',
                email: '',
                message: '',
                pet:'',
                messageSend: '',
            }
        },
      methods: {
            sendMessage: async function(){
                var responseData
                // const current = new Date();
                // const date = `${current.getDate()}/${current.getMonth()+1}/${current.getFullYear()}`;
                if(this.name != '' && this.phone != '' && this.pet == ''){
                    await axios.post('phpmailer.php', {
                        nombre: this.name,
                        telefono: this.phone,
                        mensaje: this.message
                    })
                    .then((response) => {
                    responseData = response.data
                    })
                    .catch((error) => {
                    /* eslint-disable no-console */
                    console.log(error);
                    /* eslint-enable no-console */
                    });
                    
                    if(responseData == 200 || responseData == '200') {
                        this.name = ''
                        this.phone = ''
                        this.message = ''
                        this.messageSend = 'Mensaje enviado'
                    } else {
                        this.messageSend = 'Error al enviar mensaje, intenta mas tarde.'
                    }
                } else {
                    this.messageSend = 'Ingresa la información necesaria en los campos.'
                }
            }
        }
    }
</script>

<style scoped>
/* -------------  WHATSAPP ------------- */
.whatsapp{
    position: fixed;
    bottom: 10px;
    right: 20px;
    width: 60px !important;
}
.whatsapp img{
    width: 100%;
}
/* CONTACTO */
.contact-component{
  background: #20234A;
  color: #fff;
}
.contact{
  padding-top: 5%;
  padding-bottom: 5%;
  position: relative;
}
.error{
  font-weight: 500;
  font-size: 14px !important;
  color: red;
}
.error-input{
  border-color: red !important;
}

.form-control:focus{
    background: transparent  !important;
    color: #fff !important;
}
.form-control::placeholder{
    color: #fff !important;
}
.form-control{
  background: transparent !important;
  border: 1px solid #fff;
  border-radius: 10px;
  color: #fff !important;
  height: 65px;
  font-size: 20px;
  margin-bottom: 20px !important;
}
.btn-enviar{
  border-radius: 10px;
  background: #fff !important;
  width: 100%;
  height: 60px;
  font-size: 20px;
  color: #20234A !important;
  font-weight: 500;

}
.pet-field{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -1;
}
.contact-text{
  padding-left: 40px;
  position: relative;
}
.contact-text img{
  position: absolute;
  top: 7px;
  margin-left: -30px;
}
.contact-text a{
  color: #000;
}
.contact-info{
  background: #fff;
  color: #000;
  border-radius: 20px;
  /* height: fit-content; */
  padding: 7%;
  padding-top: 10%;
  z-index: 10;
  font-size: 20px;
}
.small-square{
  background: #69714C;
  height: 80px;
  width: 80px;
  position: absolute;
  top: -30px;
  left: -30px;
}
.back{
  position: absolute;
  background: #2374C6;
  height: 100%;
  width: 250px;
  right: 0;
}

@media (max-width: 768px) {
  .logo-footer{
    width: 100px;
    margin-bottom: 20px;
  }
  .contact{
    padding-top: 15%;
    padding-bottom: 15%;
  }
  /* CONTACT */
  .back{
    display: none;
  }
  .contact-info{
    margin-top: 100px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>